import { InsuranceLayout } from "../InsuranceLayout";
import { InsuranceTiles } from "../InsuranceTiles";
import { VehiclesListCard } from "../../PolicyDetails/VehiclesListCard/VehiclesListCard";
import styles from "./InsurancePolicy.module.scss";
import { PolicyDetails } from "shared";

type InsurancePolicyProps = {
  policy: PolicyDetails;
};

export const InsurancePolicy = ({ policy }: InsurancePolicyProps) => {
  return (
    <InsuranceLayout policy={policy}>
      <InsuranceTiles policy={policy} />
      <VehiclesListCard policy={policy} className={styles.spacing} />
    </InsuranceLayout>
  );
};
